import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AtendimentoComponent } from './atendimento.component';

import { MaterialCommonModule } from 'src/app/material-modules/material-common.module';
import { ComboBeneficiarioModule } from '../common/combo-beneficiario/combo-beneficiario.module';
import { ComboMetaAtendimentoModule } from '../common/combo-meta-atendimento/combo-meta-atendimento.module';
import { ComboMetaObjetivoModule } from '../common/combo-meta-objetivo/combo-meta-objetivo.module';
import { ComboObjetivoModule } from '../common/combo-objetivo/combo-objetivo.module';
import { DadosAlunoModule } from '../common/dados-aluno/dados-aluno.module';
import { AtendimentoRoutingModule } from './atendimento-routing.module';
import { CadastrarAtendimentoComponent } from './cadastrar-atendimento/cadastrar-atendimento.component';
import { FormularioAtendimentosMetasComponent } from './formulario-atendimentos-metas/formulario-atendimentos-metas.component';


@NgModule({
  declarations: [AtendimentoComponent, CadastrarAtendimentoComponent, 
    FormularioAtendimentosMetasComponent
  ],
  imports: [
    CommonModule,
    AtendimentoRoutingModule,
    MaterialCommonModule,
    DadosAlunoModule,
    ComboBeneficiarioModule,
    ComboMetaObjetivoModule,
    ComboMetaAtendimentoModule,
    ComboObjetivoModule
  ]
})
export class AtendimentoModule { }
